// extracted by mini-css-extract-plugin
module.exports = {"btnAddMoreWrap":"ShowMoreBtn_btnAddMoreWrap__3WGAZ","btnAddMoreText":"ShowMoreBtn_btnAddMoreText__CBBhC"};